import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync as fetchAllFollowUpImportacao } from '../../../../../features/follow-up/followUpThunks';
import { selectFollowUps as selectFollowUpsImportacao } from '../../../../../features/follow-up/followUpSelectors';
import followUpExportacaoThunks from '../../../../../features/follow-up-exportacao/followUpExportacaoThunks';
import followUpExportacaoSelectors from '../../../../../features/follow-up-exportacao/followUpExportacaoSelectors';
import MultiSelectFormInput from '../../../../common/components/forms/MultiSelectFormInput';

type Props = {
  name: string;
  label: string;
};

function MultiSelectProcesso({ name, label }: Props) {
  const dispatch = useDispatch();
  const followUpsImportacao = useSelector(selectFollowUpsImportacao);
  const followUpsExportacao = useSelector(followUpExportacaoSelectors.selectFollowUps);

  useEffect(() => {
    dispatch(fetchAllFollowUpImportacao());
    dispatch(followUpExportacaoThunks.fetchAllAsync());
  }, [dispatch]);

  const options = useMemo(() => {
    const merged = [...(followUpsImportacao ?? []), ...(followUpsExportacao ?? [])];
    const byNumero = new Map<string, { id: string; value: string }>();

    merged.forEach((followUp: any) => {
      const numero = followUp?.numero;
      if (numero && !byNumero.has(numero)) {
        byNumero.set(numero, { id: numero, value: numero });
      }
    });

    return Array.from(byNumero.values());
  }, [followUpsImportacao, followUpsExportacao]);

  return <MultiSelectFormInput name={name} options={options} label={label} />;
}

export default MultiSelectProcesso;
